import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { filter, take, tap } from 'rxjs/operators';
import { ClientDataHubService } from './client-data-hub.service';
import { selectSystemInfo } from './store/misc/selectors';
import { Fx, ISystemInfo } from 'src/app/core/dto';

@Injectable({
  providedIn: 'root',
})
export class SubscriptionService {
  constructor(private clientDataHub: ClientDataHubService, private store: Store) {}

  /**
   * Runs `thunk` once, as soon as the hub is connected. It used to stay subscribed forever, so every
   * add and delete a tab had ever issued was replayed against the server on every (re)connect - a
   * burst that grew with the tab's age. Re-subscribing live subscriptions after a reconnect is now
   * done explicitly by `ClientDataEffects.resubscribeOnReconnect$`.
   */
  private fireWhenConnected(thunk) {
    this.store
      .select(selectSystemInfo)
      .pipe(
        filter((info: ISystemInfo) => info.isSignalRConnected),
        take(1),
        tap(thunk)
      )
      .subscribe();
  }

  addSubscription(subscription: Fx.Subscription) {
    this.fireWhenConnected((_) => this.clientDataHub.addSubscription(subscription));
  }
  deleteSubscription(subscription: Fx.Subscription) {
    this.fireWhenConnected((_) => this.clientDataHub.deleteSubscription(subscription));
  }
}
